import { DiscountScope } from '../models/DiscountBenefit.model';
export const getDiscountsToAlignWith = expressModel => {
  /* istanbul ignore next */
  const {
    discountBenefits = [],
    lineItems
  } = expressModel;
  let discountsToAlign = [];
  /* istanbul ignore if */
  if (!lineItems) {
    return [];
  }
  discountsToAlign = discountBenefits.filter(discountBenefit => {
    const isSpecificItemDiscountRule = discountBenefit.scope === DiscountScope.LINE_ITEM && discountBenefit.isAutomaticDiscount;
    const hasItemsWithMoreThanOneQuantity = lineItems.findIndex(lineItem => new Set(discountBenefit.lineItemIds).has(lineItem.id) && lineItem.confirmedQuantity > 1) > -1;
    return isSpecificItemDiscountRule && hasItemsWithMoreThanOneQuantity;
  });
  return discountsToAlign;
};
export const checkIfItemHasDiscount = (lineItem, discounts) => {
  return discounts.findIndex(discount => new Set(discount.lineItemIds).has(lineItem.id)) > -1;
};
export const getDiscountsValue = discountBenefits => {
  return discountBenefits.reduce((accum, discount) => {
    var _discount$amountOff;
    const amount = ((_discount$amountOff = discount.amountOff) == null ? void 0 : _discount$amountOff.amount) || /* istanbul ignore next */'0';
    return accum + Number(amount);
  }, 0);
};
//# sourceMappingURL=discounts.utils.js.map